import React from 'react'

const Loader = () => {
  return (
    <div className="loader-budget">
        <img src="images/loadergif.gif"></img>
    </div>
  )
}

export default Loader